export default __webpack_public_path__ + "static/media/194.13122ff3.jpg";